import { FormContextValues } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { referralToSpecialistTranslationKeys } from '../translations';

const ILLNESSES_ALREADY_PASSED_FIELD_NAME = 'illnessesAlreadyPassed';
type IllnessesAlreadyPassedFormBeanPart = {
   [ILLNESSES_ALREADY_PASSED_FIELD_NAME]: string | null;
};
type IllnessesAlreadyPassedTextareaProps = {
   readonly register: FormContextValues<IllnessesAlreadyPassedFormBeanPart>['register'];
};

export const IllnessesAlreadyPassedTextarea = (props: IllnessesAlreadyPassedTextareaProps): JSX.Element => {
   return (
      <Textarea
         rows={3}
         maxRows={5}
         maxLength={3600}
         focus={false}
         label={referralToSpecialistTranslationKeys.illnessesAlreadyPassed}
         controller={props.register(ILLNESSES_ALREADY_PASSED_FIELD_NAME)}
         placeholder={referralToSpecialistTranslationKeys.fillIllnessesAlreadyPassed}
         testId={'illnessesAlreadyPassed'}
      />
   );
};
